import { createAction } from "@reduxjs/toolkit";


export const resetPostOrderStatus = createAction("order/resetPostOrderStatus");